import { render, staticRenderFns } from "./ArticleComment.vue?vue&type=template&id=b7ae512c&scoped=true"
import script from "./ArticleComment.vue?vue&type=script&lang=js"
export * from "./ArticleComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ae512c",
  null
  
)

export default component.exports